import classNames from 'classnames'

import { useUk } from '../../../hooks'

import * as styles from './CompanyLogo.module.css'

function CompanyLogo({ className = styles.CompanyLogo, collapsed = false }) {
  const { logo, logo_mobile } = useUk()

  const expandedLogo = logo?.origin
  const collapsedLogo = logo_mobile?.origin

  const collapsedSrc = collapsedLogo ?? expandedLogo
  const expandedSrc = expandedLogo ?? collapsedLogo

  const logoClassName = classNames(className, {
    [styles.collapsed]: collapsed,
    [styles.expanded]: !collapsed,
  })

  return expandedSrc || collapsedSrc ? (
    <div className={logoClassName}>
      <img alt='' className={styles.expandedLogo} src={expandedSrc} />
      <img alt='' className={styles.collapsedLogo} src={collapsedSrc} />
    </div>
  ) : null
}

export default CompanyLogo
